import { createContext } from "react";

import type { Settings } from "../types/settings";

const initialSettings: Settings = {
  paletteMode: "dark",
  pinNav: true,
  rowCount: 25,
};

interface State extends Settings {
  isInitialized: boolean;
}

const initialState: State = {
  ...initialSettings,
  isInitialized: false,
};

export interface SettingsContextType extends State {
  handleReset: () => void;
  handleUpdate: (settings: Settings) => void;
  isCustom: boolean;
}

export const SettingsContext = createContext<SettingsContextType>({
  ...initialState,
  handleReset: () => {},
  handleUpdate: () => {},
  isCustom: false,
});

export const SettingsConsumer = SettingsContext.Consumer;

export { initialSettings };
